import Chart from './components/Chart'
import {
  Coord,
  Axis,
  Guide,
  Geom,
  Tooltip,
  Legend,
  PieLabel,
} from './components/SubComponent'

import valueLabelPlugin from './plugins/valueLabelPlugin'
import elasticPainterPlugin from './plugins/elasticPainterPlugin'

import { DEFAULT_THEME_KEY } from './constant'

export default {
  components: {
    Chart,
    Coord,
    Axis,
    Guide,
    Geom,
    Tooltip,
    Legend,
    PieLabel,
  },

  plugins: {
    valueLabelPlugin,
    elasticPainterPlugin,
  },

  constants: {
    DEFAULT_THEME_KEY,
  },
}
